import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const ifritProperty = new SummonDataProperty(
  "ea81a495-14f5-4f5f-a791-7c8af846ea00",
  "Ifrit",
)
